import { useMediaQuery } from "hooks";

const BREAKPOINT = 768;

const useIsMobile = () => {
  const isMobile = useMediaQuery(BREAKPOINT);
  return isMobile;
};

export default useIsMobile;
